const style = {
  title: {
    fontSize: `12px`,
    cursor: `pointer`
  },
  value: {
    fontStyle: `italic`
  },
  active: {
    color: `#A94545`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Support/style/filter.js